export const FETCh_AGENT_DETAILS_LOADING  = "FETCH_AGENT_DETAILS_LOADING";
export const FETCh_AGENT_DETAILS  = "FETCH_AGENT_DETAILS";
export const FETCH_AGENT_DETAILS_FAILED = "FETCH_AGENT_DETAILS_FAILED";